export default {
  apiTrafficManager: 'https://talmudfinder-2-0.loadbalancer.dicta.org.il/TalmudFinder',
}
